"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.constantRoutes = exports.asyncRoutes = void 0;
exports.resetRouter = resetRouter;
var _typeof2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/typeof.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
var _vue = _interopRequireDefault(require("vue"));
var _vueRouter = _interopRequireDefault(require("vue-router"));
var _layout = _interopRequireDefault(require("@/layout"));
var _school = _interopRequireDefault(require("@/router/modules/school"));
var _object = _interopRequireDefault(require("@/router/modules/object"));
var _technocracy = _interopRequireDefault(require("@/router/modules/technocracy"));
var _entryDesign = _interopRequireDefault(require("@/router/modules/entryDesign"));
var _webSet = _interopRequireDefault(require("@/router/modules/webSet"));
var _userInfo = _interopRequireDefault(require("@/router/modules/userInfo"));
var _publicAdmin = _interopRequireDefault(require("@/router/modules/publicAdmin"));
var _jury = _interopRequireDefault(require("@/router/modules/jury"));
var _courseDeclare = _interopRequireDefault(require("@/router/modules/courseDeclare"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != (0, _typeof2.default)(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); } /* Layout */ // import officeRouter from "@/router/modules/office";
/* Router Modules */

_vue.default.use(_vueRouter.default);

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
var asyncRoutes = exports.asyncRoutes = [_school.default, _object.default, _technocracy.default, _entryDesign.default, _webSet.default, _userInfo.default, _courseDeclare.default,
// 404 page must be placed at the end !!!
{
  path: '*',
  redirect: '/404',
  hidden: true
}];

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
var constantRoutes = exports.constantRoutes = [{
  path: '/redirect',
  component: _layout.default,
  hidden: true,
  children: [{
    path: '/redirect/:path*',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/redirect/index'));
      });
    }
  }]
}, {
  path: '',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/views/login/index'));
    });
  },
  hidden: true,
  redirect: "/",
  children: [{
    path: "/",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/homePage/index.vue'));
      });
    },
    meta: {
      title: "首页"
    }
  }, {
    path: "/reNews",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/news/index.vue'));
      });
    },
    meta: {
      title: "新闻中心"
    }
  }, {
    path: "/recommendCourse",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/recommendCourse.vue'));
      });
    },
    meta: {
      title: "推荐课程"
    }
  }, {
    path: "/courseDetail",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/courseDetail.vue'));
      });
    },
    meta: {
      title: "课程详情"
    }
  }, {
    path: "/professionalTeaching",
    name: "professionalTeaching",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/professionalTeaching/index.vue'));
      });
    },
    meta: {
      title: "专业教学资源库"
    }
  }, {
    path: "/professionalTeachingCourse",
    name: "professionalTeachingCourse",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/professionalTeaching/courseList.vue'));
      });
    },
    meta: {
      title: "专业教学资源库课程"
    }
  }, {
    path: "/deYu",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/deyu/index.vue'));
      });
    },
    meta: {
      title: "德育"
    }
  }, {
    path: "/tiYu",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/tiYu/index.vue'));
      });
    },
    meta: {
      title: "体育"
    }
  }, {
    path: "/meiYu",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/meiYu/index.vue'));
      });
    },
    meta: {
      title: "美育"
    }
  }, {
    path: "/characteristics",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/characteristics/index.vue'));
      });
    },
    meta: {
      title: "思政课程"
    }
  }, {
    path: "/allModule",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/allModule/index.vue'));
      });
    },
    meta: {
      title: "全部"
    }
  }, {
    path: "/characteristic",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/characteristic/index.vue'));
      });
    },
    meta: {
      title: "首都特色教育"
    }
  }, {
    path: "/communityEducation",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/communityEducation/index.vue'));
      });
    },
    meta: {
      title: "社区教育"
    }
  }, {
    path: "/oldAgeEducation",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/oldAgeEducation/index.vue'));
      });
    },
    meta: {
      title: "老龄教育"
    }
  }, {
    path: "/learning",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/learning/index.vue'));
      });
    },
    meta: {
      title: "终身学习"
    }
  }, {
    path: "/collegeEngineers",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/collegeEngineers/index.vue'));
      });
    },
    meta: {
      title: "工程师学院"
    }
  }, {
    path: "/teacherPower",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/teacherPower/index.vue'));
      });
    },
    meta: {
      title: "教师能力提升中心"
    }
  }, {
    path: "/boutiqueCourse",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/boutiqueCourse/index.vue'));
      });
    },
    meta: {
      title: "精品在线课程"
    }
  }, {
    path: "/virtual",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/virtual/index.vue'));
      });
    },
    meta: {
      title: "虚拟仿真"
    }
  }, {
    path: "/books",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/books/index.vue'));
      });
    },
    meta: {
      title: "新形态教材"
    }
  }, {
    path: "/virtualCourse",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/virtualCourse/index.vue'));
      });
    },
    meta: {
      title: "视频公开课"
    }
  }, {
    path: "/competition",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/competition/index.vue'));
      });
    },
    meta: {
      title: "赛事专栏"
    }
  }, {
    path: "/competitionDetail",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/competition/detail.vue'));
      });
    },
    meta: {
      title: "比赛详情"
    }
  }, {
    path: "/newsDetail",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/news/newsDetail.vue'));
      });
    },
    meta: {
      title: "新闻详情"
    }
  }, {
    path: "/register",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/register/register.vue'));
      });
    },
    meta: {
      title: "注册"
    }
  }, {
    path: "/registerEdit",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/register/edit.vue'));
      });
    },
    meta: {
      title: "注册信息修改"
    }
  }, {
    path: "/courseSearch",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/homePage/courseSearch.vue'));
      });
    },
    meta: {
      title: "课程搜索"
    }
  }, {
    path: "/semanticSearch",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/homePage/semanticSearch.vue'));
      });
    },
    meta: {
      title: "语义检索"
    }
  }]
}, {
  path: "/userService",
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/views/login/userService/index.vue'));
    });
  },
  meta: {
    title: "用户服务协议"
  },
  hidden: true
}, {
  path: "/userServiceTwo",
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/views/login/userServiceTwo/index.vue'));
    });
  },
  meta: {
    title: "用户隐私协议"
  },
  hidden: true
}, {
  path: '/bjlogin',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require("../views/login/bjlogin/index.vue"));
    });
  },
  meta: {
    title: "登录页面"
  },
  hidden: true
}, {
  path: '/teacherMatch',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/views/login/teacherMatch/warp.vue'));
    });
  },
  hidden: true,
  redirect: "/teacherIndex",
  children: [{
    path: "/teacherIndex",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/teacherMatch/index.vue'));
      });
    },
    meta: {
      title: "班主任教学能力大赛首页"
    }
  }, {
    path: "/teacherNews",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/teacherMatch/news.vue'));
      });
    },
    meta: {
      title: "大赛新闻"
    }
  }, {
    path: "/teacherNewsDetail",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/teacherMatch/newsDetail.vue'));
      });
    },
    meta: {
      title: "大赛新闻"
    }
  }, {
    path: "/yearView",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/teacherMatch/yearView.vue'));
      });
    },
    meta: {
      title: "历年作品展示"
    }
  }, {
    path: "/hisWorks",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/teacherMatch/hisWorks.vue'));
      });
    },
    meta: {
      title: "历年作品展示"
    }
  }, {
    path: "/yearViewDetail",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/teacherMatch/yearViewDetail.vue'));
      });
    },
    meta: {
      title: "历年作品详情"
    }
  }]
}, {
  path: '/auth-redirect',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/views/login/auth-redirect'));
    });
  },
  hidden: true
}, {
  path: '/404',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/views/error-page/404'));
    });
  },
  hidden: true
}, {
  path: '/401',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/views/error-page/401'));
    });
  },
  hidden: true
}, {
  path: '/ht',
  component: _layout.default,
  redirect: 'dashboard',
  children: [{
    path: '/dashboard',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/dashboard/index'));
      });
    },
    name: 'Dashboard',
    meta: {
      title: '首页',
      icon: 'dashboard',
      affix: true
    }
  }]
}, {
  path: '/profile',
  component: _layout.default,
  redirect: '/profile/index',
  hidden: true,
  children: [{
    path: 'index',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/profile/index'));
      });
    },
    name: 'Profile',
    meta: {
      title: '个人信息',
      icon: 'user',
      noCache: true
    }
  }]
},
//  {
//     path: '/college',
//     component: () => import('@/views/collegeEdition/layout'),
//     hidden: true,
//     redirect: "/:code",
//     children: [
//     {
//       path: '/teachingMaterial',
//       name:'teachingMaterial',
//       component: () => import('@/views/collegeEdition/teachingMaterial')
//     },
//       {
//         path: '/openCourse',
//         name:'openCourse',
//         component: () => import('@/views/collegeEdition/openCourse')
//       },
//       {
//         path: '/fictitiousCourse',
//         name:'fictitiousCourse',
//         component: () => import('@/views/collegeEdition/fictitiousCourse')
//       },
//       {
//         path: '/majorSource',
//         name:'majorSource',
//         component: () => import('@/views/collegeEdition/majorSource')
//       },
//       {
//         path: '/onlineCourse',
//         name:'onlineCourse',
//         component: () => import('@/views/collegeEdition/onlineCourse')
//       },
//       {
//         path: '/:code',
//         name:'college',
//         component: () => import('@/views/collegeEdition/index')
//       }
//     ]
//   },

// ============================================================
// 国际专区路由组 — 接口驱动的最新版本
// ============================================================
{
  path: '/international',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/views/login/international/index.vue'));
    });
  },
  redirect: '/international/home',
  children: [{
    path: 'home',
    name: 'IntlHome',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/international/home/index.vue'));
      });
    },
    meta: {
      title: '国际专区'
    }
  }, {
    path: 'news',
    name: 'IntlNews',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/international/news/index.vue'));
      });
    },
    meta: {
      title: '国际化动态'
    }
  }, {
    path: 'newsDetail',
    name: 'IntlNewsDetail',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/international/news/detail.vue'));
      });
    },
    meta: {
      title: '动态详情'
    }
  }, {
    path: 'courses',
    name: 'IntlCourses',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/international/courses/index.vue'));
      });
    },
    meta: {
      title: '课程资源'
    }
  }, {
    path: 'courseDetail',
    name: 'IntlCourseDetail',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/international/courses/detail.vue'));
      });
    },
    meta: {
      title: '课程详情'
    }
  }, {
    path: 'courseLearn',
    name: 'IntlCourseLearn',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/international/courses/learn.vue'));
      });
    },
    meta: {
      title: '课程学习'
    }
  }, {
    path: 'about',
    name: 'IntlAbout',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/international/about/index.vue'));
      });
    },
    meta: {
      title: '国际交流'
    }
  }]
}];
var createRouter = function createRouter() {
  return new _vueRouter.default({
    // mode: 'history', // require service support
    mode: 'history',
    routes: constantRoutes
  });
};
/**
 * 重写路由的push方法
 */
var routerPush = _vueRouter.default.prototype.push;
_vueRouter.default.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(function (error) {
    return error;
  });
};
var router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}
var _default = exports.default = router;